import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Dialog,
    DialogContent,
    FormControl,
    TextField,
    TablePagination,
    DialogTitle,
    DialogActions,
    Button,
    Divider,
    FormHelperText
} from "@material-ui/core";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import HttpService from "../../services/httpService";
import { ROLENAME } from "../../utils/index";
import { RiCheckboxCircleLine } from "react-icons/ri";
import { AiOutlineInteraction } from "react-icons/ai";
import moment from "moment";
import { Link } from "react-router-dom";
import { DatePicker } from "@material-ui/pickers";
import { MdEmail } from "react-icons/md";
import { CSVLink } from "react-csv";
import { RiFileExcel2Fill } from "react-icons/ri";



const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
    },
    title: {
        fontWeight: 700,
        color: "#1e293b",
        marginBottom: "32px",
        textAlign: "center",
    },
    headerCell: {
        backgroundColor: "#1c365c",
        color: "white",
        fontWeight: "bold",
        fontSize: "18px",
        padding: "20px",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        position: "sticky",
        top: 0,
        textAlign: "center",
        zIndex: 1,
    },
    tableRowEven: {
        backgroundColor: "#ffffff",
    },
    tableRowOdd: {
        backgroundColor: "#f0f4f8",
    },
    cell: {
        fontSize: "16px",
        fontWeight: "bold",
        padding: "20px",
        borderRight: "1px solid #e0e0e0",
        color: "#263238",
    },
    valueCell: {
        fontSize: "18px",
        fontWeight: "bold",
        padding: "20px",
        color: "#0d47a1",
        borderRight: "1px solid #e0e0e0",
        textAlign: "center",
        cursor: "pointer",
        "&:hover": {
            backgroundColor: "#e3f2fd",
        },
    },
    paper: {
        textAlign: "center",
    },
}));

const useStylesTable = makeStyles((theme) => ({
    root: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: "1px solid #eee5e5",
        background: "blue",
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: "100%",
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial",
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: "#FDB913",
        color: "#151921",
        padding: "1",
        marginRight: "0.5em",
        borderRadius: "20px",
        width: "20%",
        "&:hover": { backgroundColor: "#14419c", color: "white" },
    },
    leadClearButton: {
        backgroundColor: "#f7b7b7", // light red background
        color: "#151921",
        padding: "1",
        marginRight: "0.5em",
        borderRadius: "20px",
        width: "20%",
        // "&:hover": {
        //     backgroundColor: "#f7b7b7", // same light red on hover
        //     color: '#151921' // same text color on hover
        // }
    },
    submitButton: {
        backgroundColor: "#1c365c !important", // Decorpot Orange
        color: "white", // White text
        "&:hover": {
            backgroundColor: "#E0663D !important", // Darker Orange on hover
        },
    },
    clearButton: {
        backgroundColor: "#FFF2EB !important", // Light Beige
        color: "#1C375D !important", // Decorpot Orange text
        "&:hover": {
            backgroundColor: "#E7BAD0 !important", // Light Pink on hover
        },
    },
    searchButton: {
        backgroundColor: "#FDB913 !important", // Bright Yellow for emphasis
        color: "#1C375D !important", // Dark Blue text for contrast
        "&:hover": {
            backgroundColor: "#E6A411 !importan", // Darker yellow on hover
        },
    },
}));

const InitiationBomDataTable = (props) => {
    const classes = useStyles();
    const csvRef = useRef();
    const classesTable = useStylesTable();
    const { userDetails } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const [commonExpCenter, setExpCenter] = useState([]);
    const [commonLocation, setLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState(
        []
    );
    const [storeDateFilter, setStoreDateFilter] = useState({
        startDate: "",
        endDate: "",
    });
    const [selectedRole, setSelectedRole] = useState([]);
    const [selectedQCStage, setSelectedQCStage] = useState([]);
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const searchTypes = [
        "Customer Name",
        "Email ID",
        "Lead No",
        "Project No",
        "Contact No",
        "Unique Lead No",
    ];
    const [usersData, setUsersData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [page, setPage] = useState(0);
    const [open, setOpen] = useState(false);
    const [mainOpen, setMainOpen] = useState(false);
    const [subOpen, setSubOpen] = useState(false);
    const [selectedAction, setSelectedAction] = useState("");
    const [formData, setFormData] = useState({
        workStartDate: "",
        workEndDate: "",
        followUpDate: "",
        reasonForHold: "",
    });
    const [clearTriggered, setClearTriggered] = useState(false);
    const [initiationData, setInitiationData] = useState([]);
    const [selectedLeadId, setSelectedLeadId] = useState("");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [csvData, setCsvData] = useState([]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        setPage(0);
    }, [initiationData]);


    useEffect(() => {
        if (clearTriggered) {
            initiationBomTableApi();
            setClearTriggered(false);
        }
    }, [clearTriggered]);

    useEffect(() => {
        initiationBomTableApi();
        expCenters();
        locations();
    }, []);

    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter((user) => {
                return userDetails?.experienceCenterId?.includes(user._id);
            });
            setExpCenter(matchedUsers);
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const locations = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getLocation();
            const matchedUsers = response.data.filter((user) => {
                return userDetails?.selectedLocation?.includes(user._id);
            });
            setLocation(matchedUsers);
        } catch (error) {
            console.error("Error fetching locations:", error);
            props.setSnackInfo(
                error?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const fetchUsersData = async (data) => {
        let obj = {
            role: data,
            pivotValue: "value",
        };
        try {
            let response = await HttpService.selectedUsersBasedOnQCRole(obj);
            setUsersData(response.data);
        } catch (error) {
            console.log(error, "error");
        }
    };

    const roleName = userDetails.roles.map((role) => role.name);

    const defaultOptions = [
        { value: ROLENAME.DGM_Ops, label: "DGM OPS" },
        { value: ROLENAME.OperationManager, label: "OPS Manager" },
    ];

    const roleOptionsMap = {
        Admin: defaultOptions,
        "DGM Ops": [
            { value: ROLENAME.OperationDesignManager, label: "OPS Manager" },
        ],
    };

    // Determine highest priority role (first one matched)
    const matchedRole = ["Admin", "DGM Ops", "Operation Manager",].find((role) =>
        roleName.includes(role)
    );

    const optionsToShow = matchedRole
        ? roleOptionsMap[matchedRole]
        : defaultOptions;

    const actions = ["In Progress", "Hold",];

    const handleMainOpen = (leadId) => {
        setSelectedLeadId(leadId);
        setMainOpen(true);
    };
    const handleMainClose = () => setMainOpen(false);

    const handleSelectAction = (action) => {
        setSelectedAction(action);
        setMainOpen(false);
        setSubOpen(true);
    };

    const handleSubClose = () => setSubOpen(false);

    // this is ops Table Data API.
    const initiationBomTableApi = async () => {

    let expCenterData = selectedExperienceCenter?.map((el) => el._id);
    let locationData = selectedLocation?.map((el) => el._id);
    let userLocationData = userDetails?.locationId?.map((el) => el._id);
    let userExpeData = userDetails?.experienceCenterId.map((el) => el);
    let selectedUserData = selectedUsers?.map((el) => el._id);
    const obj = {
        startDate: storeDateFilter.startDate,
        endDate: storeDateFilter.endDate,
        selectedExperienceCenter: expCenterData ? expCenterData : "",
        selectedLocation: locationData ? locationData : "",
        searchType: selectedSearchType ? selectedSearchType : "",
        search: searchInput ? searchInput.toUpperCase() : "",
        pivotValue: 'drawingQC',
        selectedRole : selectedRole ? selectedRole : "",
        selectedUsers: selectedUserData ? selectedUserData : "",
        selectedQCStage: selectedQCStage ? selectedQCStage : "",
        userId: userDetails?._id,
        userExpeCenterId: userExpeData ? userExpeData : "",
        userLocationData: userLocationData ? userLocationData : "",
    }

    props.setLoading(true);
    try {
        let response = await HttpService.getUnderExecutionLeadsForInitiationBomDataTable(obj);
        setInitiationData(response.data);
    } catch (error) {
        props.setSnackInfo(error, "error")
    }

    props.setLoading(false);
    }

    const handleSubmitAllFilters = () => {
        setPage(0); 
        initiationBomTableApi()
    };

     const handleClearAllFilters = () => {
        setSelectedLocation([]);
        setSelectedExperienceCenter([]);
        setSelectedUsers([])
        setStoreDateFilter({ startDate: '', endDate: '' });
        setSelectedRole('');
        setSelectedQCStage('');
        setSelectedSearchType('');
        setSearchInput('');
        setPage(0); 
        setClearTriggered(true);
    };

    const isSubmitDisabled = !(
        selectedLocation.length > 0 ||
        selectedExperienceCenter.length > 0 ||
        storeDateFilter.startDate ||
        storeDateFilter.endDate ||
        selectedRole.length > 0 ||
        selectedQCStage.length > 0 ||
        selectedUsers.length > 0 ||
        (selectedSearchType && searchInput)
    );

    const initialFormData = {
        workStartDate: "",
        workEndDate: "",
        followUpDate: "",
        reasonForHold: "",
    };

    const initiationBomTableOps = async () => {
        props.setLoading(true);

        try {
            const payload = {
                selectedAction,
                formData,
                leadId: selectedLeadId,
            };

            const response = await HttpService.initiationBomTableOps(payload);

            if (!response?.data?.success) {
                props.setSnackInfo(
                    response?.data?.message || "Operation failed",
                    "error"
                );
                return;
            }

            props.setSnackInfo(
                response?.data?.message || "Lead Updated successfully",
                "success"
            );

            setFormData(initialFormData);
            setSelectedAction("");
            setSelectedLeadId(null);
            initiationBomTableApi();
            setSubOpen(false);

        } catch (error) {
            props.setSnackInfo(
                error?.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            props.setLoading(false);
        }
    };

      const csvHeaders = [
        { label: "S. No", key: "serialNo" },
        { label: "Project No", key: "projectCode" },
        { label: "Customer Name", key: "clientName" },
        { label: "Location", key: "expCtrName" },
        { label: "Initiation Bom approved date", key: "approvedAt" },
        { label: "Status", key: "initiationStatus" },
        { label: "Work Start Date", key: "initiationWorkStartDate" },
        { label: "Work End Date", key: "initiationWorkEndDate" },
        { label: "Tentative Work Start Date", key: "initiationTentativeWorkStartDate" },
        { label: "Tentative Work End Date", key: "initiationTentativeWorkEndDate" },
        { label: "Follow-up Date", key: "initiationFollowUpDate" },
        { label: "Hold Reason", key: "initiationHoldReason" },
        { label: "Customer remarks", key: "initiationCustomerRemarks" },
        { label: "Customer Resume Date", key: "initiationCustomerResumeDate" },
    ];

    const formatDate = (date) =>
        date && moment(date).isValid()
            ? moment(date).format("DD-MM-YYYY")
            : "NA";

  
    const handleDownload = () => {
        const csvFormattedData = initiationData.map((item, index) => ({
            serialNo: index + 1,
            projectCode: item?.erpProjectNo || "NA",
            clientName: item?.clientName || "NA",
            expCtrName: item?.experienceCenterName || "NA",
            approvedAt: formatDate(item?.approvedAt),
            initiationStatus:
                item?.initiationStatus === "Pending Hold Approval"
                ? "Hold Pending Approval"
                : item?.initiationStatus || "Pending",
            initiationWorkStartDate: formatDate(item?.initiationWorkStartDate),
            initiationWorkEndDate: formatDate(item?.initiationWorkEndDate),
            initiationTentativeWorkStartDate: formatDate(item?.initiationTentativeWorkStartDate),
            initiationTentativeWorkEndDate: formatDate(item?.initiationTentativeWorkEndDate),
            initiationFollowUpDate: formatDate(item?.initiationFollowUpDate),
            initiationCustomerResumeDate: formatDate(item?.initiationCustomerResumeDate),

            initiationHoldReason: item?.initiationHoldReason || "NA",
            initiationCustomerRemarks: item?.initiationCustomerRemarks || "NA",
            }));
        setCsvData(csvFormattedData);
        setTimeout(() => csvRef.current.link.click());
    };

    return (
        <div className='App'>
            {/* This is all the Filters Section */}
            <br />
            <div>
                <Paper
                    style={{
                        padding: "2rem",
                        borderRadius: "10px",
                        boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                    }}>
                    {/* === Filters: Location, Exp Center, Dates === */}
                    <Grid
                        container
                        spacing={2}
                        alignItems='center'
                        style={{ marginBottom: "1rem" }}>
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    value={selectedLocation}
                                    options={commonLocation}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, val) =>
                                        setSelectedLocation(val)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='Select Location'
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    value={selectedExperienceCenter}
                                    options={commonExpCenter}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, val) =>
                                        setSelectedExperienceCenter(val)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='Select Exp-Center'
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label='To Date'
                                type='date'
                                variant='outlined'
                                value={storeDateFilter.startDate}
                                onChange={(e) =>
                                    setStoreDateFilter({
                                        ...storeDateFilter,
                                        startDate: e.target.value,
                                    })
                                }
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                label='End Date'
                                type='date'
                                variant='outlined'
                                value={storeDateFilter.endDate}
                                onChange={(e) =>
                                    setStoreDateFilter({
                                        ...storeDateFilter,
                                        endDate: e.target.value,
                                    })
                                }
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                            />
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        alignItems='center'
                        style={{ marginBottom: "1.5rem" }}>
                        {/* <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Select Role'
                                    variant='outlined'
                                    value={selectedRole}
                                    onChange={(e) => {
                                        setSelectedRole(e.target.value);
                                        fetchUsersData(e.target.value);
                                    }}>
                                    {optionsToShow.map((item, index) => (
                                        <MenuItem
                                            key={index}
                                            value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <FormControl
                                style={{ width: "100%", marginTop: "0.30rem" }}>
                                <Autocomplete
                                    multiple
                                    value={selectedUsers}
                                    options={usersData}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, val) => setSelectedUsers(val)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label='Select Users'
                                            variant='outlined'
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid> */}
                        <Grid item xs={12} sm={3}>
                            <FormControl fullWidth>
                                <TextField
                                    select
                                    label='Select Status'
                                    variant='outlined'
                                    value={selectedQCStage}
                                    onChange={(e) =>
                                        setSelectedQCStage(e.target.value)
                                    }>
                                    <MenuItem value={"Pending"}>Pending</MenuItem>
                                    <MenuItem value={"InProgress"}>In Progress</MenuItem>
                                    <MenuItem value={"Pending Hold Approval"}>Hold Approval Pending</MenuItem>
                                    <MenuItem value={"Hold"}>Hold</MenuItem>
                                    <MenuItem value={"Hold Rejected"}>Hold Rejected</MenuItem>
                                </TextField>
                            </FormControl>
                        </Grid>
                    </Grid>

                    {/* === Search Type + Input + Submit & Clear === */}
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: "1rem",
                            marginTop: "20px",
                        }}>
                        <TextField
                            select
                            label='Search Type'
                            value={selectedSearchType}
                            onChange={(e) =>
                                setSelectedSearchType(e.target.value)
                            }
                            variant='outlined'
                            style={{ width: "20%" }}
                            size='small'>
                            <MenuItem value=''>None</MenuItem>
                            {searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>
                                    {el}
                                </MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            label='Enter the input'
                            size='small'
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            variant='outlined'
                            style={{ flexGrow: 1, minWidth: "300px" }}
                        />

                        <Button
                            variant='contained'
                            color='primary'
                            size='medium'
                            style={{
                                color: "#fff",
                                padding: "4px 20px",
                                whiteSpace: "nowrap",
                                backgroundColor: isSubmitDisabled ? "#cccccc" : "#4caf50",
                                opacity: isSubmitDisabled ? 0.5 : 1,
                            }}
                            onClick={handleSubmitAllFilters}
                            disabled={isSubmitDisabled}
                            >
                            Submit
                        </Button>

                        <Button
                            variant='contained'
                            color='secondary'
                            size='medium'
                            style={{
                                backgroundColor: "#f44336",
                                color: "#fff",
                                padding: "4px 20px",
                                whiteSpace: "nowrap",
                            }}
                            onClick={handleClearAllFilters}
                            >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            {/* This is all the Filters Section End */}

            {/* Table Section Start */}
            <br />
            <div> 
                <Box className={classes.root}>
                    <Typography variant='h4' className={classes.title}>
                        Initiation BOM Table
                    </Typography>
                     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '10px 0' }}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component='div'
                            count={initiationData.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                        
                        <Button
                            variant="contained"
                            style={{ backgroundColor: "#355025", color: "#FFF2EB" }}
                            onClick={handleDownload}
                        >
                            <RiFileExcel2Fill style={{ fontSize: "20px", marginRight: '5px' }} />
                            Download CSV
                        </Button>

                        <CSVLink
                            data={csvData}
                            headers={csvHeaders}
                            filename={`drawing-table-${props.clickType || 'data'}.csv`}
                            ref={csvRef}
                            style={{ display: "none" }}
                        />
                    </div>
                    <TableContainer component={Paper} style={{ flexGrow: 1 }}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.headerCell}>
                                        S. No
                                    </TableCell>
                                    {[
                                        "Project No",
                                        "Customer Name",
                                        "Location",
                                        "Initiation Bom approved date",
                                        "Status",
                                        "Work Start Date",
                                        "Work End Date",
                                        "Tentative Work Start Date",
                                        "Tentative Work End Date",
                                        "Follow-up Date",
                                        "Hold Reason",
                                        // "Customer Hold Status",
                                        "Customer remarks",
                                        "Customer Resume Date",
                                        ...(userDetails.roles.some(role => role.name === "Senior Operation Manager" || role.name === "Operation Manager") ? ["Action"] : []),
                                    ].map((header, index) => (
                                        <TableCell
                                            key={index}
                                            className={classes.headerCell}>
                                            {header}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            {initiationData
                                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => (
                                <TableRow
                                    key={row?._id || index}
                                    className={index % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}
                                >
                                    <TableCell className={classes.cell}>{page * rowsPerPage + index + 1}</TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.erpProjectNo ? (
                                            <Link to={`/project-logs/${row?.leadId}`} target="_blank" rel="noopener noreferrer" style={{ color: "black", textDecoration: 'underline' }}>
                                            {row.erpProjectNo}
                                            </Link>
                                        ) : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.clientName || 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.experienceCenterName || 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.approvedAt ? moment(row.approvedAt).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationStatus === "Pending Hold Approval" ? "Hold Pending Approval" : row?.initiationStatus || 'Pending'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationWorkStartDate ? moment(row.initiationWorkStartDate).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationWorkEndDate ? moment(row.initiationWorkEndDate).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationTentativeWorkStartDate ? moment(row.initiationTentativeWorkStartDate).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationTentativeWorkEndDate ? moment(row.initiationTentativeWorkEndDate).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationFollowUpDate ? moment(row.initiationFollowUpDate).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>

                                    <TableCell className={classes.cell}>
                                        {row?.initiationHoldReason || 'NA'}
                                    </TableCell>
                                    {/* <TableCell className={classes.cell}>
                                        {row?.initiationCustomerHoldStatus || 'NA'}
                                    </TableCell> */}
                                    <TableCell className={classes.cell}>
                                        {row?.initiationCustomerRemarks || 'NA'}
                                    </TableCell>
                                    <TableCell className={classes.cell}>
                                        {row?.initiationCustomerResumeDate ? moment(row.initiationCustomerResumeDate).format("DD-MM-YYYY") : 'NA'}
                                    </TableCell>
                                    {(userDetails.roles.find(role => role.name === "Senior Operation Manager" || role.name === "Operation Manager")) && (
                                    <TableCell className={classes.notesCell}>
                                        <AiOutlineInteraction
                                            style={{
                                                color: "#4caf50",
                                                cursor: "pointer",
                                                fontSize: "35px",
                                                transition: "0.3s",
                                                marginLeft: "18px",
                                            }}
                                            onClick={() => handleMainOpen(row.leadId)}
                                        />
                                    </TableCell>)}

                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </div>
            <br />
            {/* Table Section End */}

            {/* MAIN POPUP */}
            <Dialog
                open={mainOpen}
                onClose={handleMainClose}
                maxWidth='xs'
                fullWidth>
                <DialogTitle>Please Select a Status</DialogTitle>
                <DialogContent>
                    <Box sx={{display: 'flex', flexDirection: 'row', gap: 10, alignContent: 'center', justifyContent: 'center', flexWrap: 'wrap', marginTop: 2}}>
                        {actions.map((action) => (
                            <Button
                                key={action}
                                variant='outlined'
                                color='primary'
                                onClick={() => handleSelectAction(action)}
                                style={{
                                    borderRadius: 8,
                                    padding: "12px 5px",
                                    fontWeight: 600,
                                    textTransform: "capitalize",
                                    background: "#f5f8ff",
                                    borderColor: "#c5d4f0",
                                    transition: "0.3s",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#e3ecff")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f8ff")}
                            >
                                {action}
                            </Button>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleMainClose} color='secondary'>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/* SUB POPUP */}
            <Dialog
                open={subOpen}
                onClose={handleSubClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    style: {
                    borderRadius: 18,
                    padding: 6,
                    },
                }}
                >
                <DialogTitle style={{ paddingBottom: 8 }}>
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                    {selectedAction} Details
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                    Please provide the required information
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Box mt={2} display="flex" flexDirection="column">

                        {/* Work Start Date */}
                        {(selectedAction === "In Progress" ||
                        selectedAction === "Hold") && (
                        <TextField
                            // label="Work Start Date"
                            label={selectedAction === "Hold" ? "Tentative Work Start Date" : "Work Start Date"}
                            type="date"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            value={formData.workStartDate}
                            onChange={(e) =>
                            setFormData({
                                ...formData,
                                workStartDate: e.target.value,
                            })
                            }
                            inputProps={{ min: new Date().toISOString().split("T")[0] }}

                        />
                        )}

                        {/* Work End Date */}
                        {(selectedAction === "In Progress" ||
                        selectedAction === "Hold") && (
                        <TextField
                            // label="Work End Date"
                            label={selectedAction === "Hold" ? "Tentative Work End Date" : "Work End Date"}
                            type="date"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            value={formData.workEndDate}
                            onChange={(e) =>
                            setFormData({
                                ...formData,
                                workEndDate: e.target.value,
                            })
                            }
                            inputProps={{ min: new Date().toISOString().split("T")[0] }}
                        />
                        )}

                        {/* Follow-up Date */}
                        {selectedAction === "Hold" && (
                        <TextField
                            label="Follow-up Date"
                            type="date"
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            value={formData.followUpDate}
                            onChange={(e) =>
                            setFormData({
                                ...formData,
                                followUpDate: e.target.value,
                            })
                            }
                            inputProps={{ min: new Date().toISOString().split("T")[0] }}
                        />
                        )}

                        {/* Reason For Hold */}
                        {selectedAction === "Hold" && (
                            <>
                        <TextField
                            label="Reason For Hold"
                            placeholder="Enter reason for holding this request..."
                            multiline
                            minRows={3}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            value={formData.reasonForHold}
                            onChange={(e) =>
                            setFormData({
                                ...formData,
                                reasonForHold: e.target.value,
                            })
                            }
                        />
                        <FormHelperText style={{ marginLeft: 14 }}>
                            Note: On submitting the HOLD request, an email will be sent to the customer.
                        </FormHelperText>
                        </>
                        )}

                    </Box>
                </DialogContent>

                <DialogActions style={{ padding: 16 }}>
                    {selectedAction === "Customer Hold Request" && (
                        <Button
                            variant="outlined"
                            startIcon={<MdEmail style={{ color: "green" }}/>}
                            style={{
                            borderRadius: 20,
                            padding: "6px 20px",
                            }}
                            onClick={initiationBomTableOps} // your existing or future handler
                        >
                            Send Mail To Customer
                        </Button>
                    )}

                    {selectedAction !== "Customer Hold Request" && (
                        <Button
                        onClick={handleSubClose}
                        variant="outlined"
                        style={{ borderRadius: 20, padding: "6px 20px" }}
                        >
                        Cancel
                        </Button>
                    )}
                    {selectedAction !== "Customer Hold Request" && (
                        <Button
                        onClick={initiationBomTableOps}
                        color="primary"
                        variant="contained"
                        style={{
                            borderRadius: 20,
                            padding: "6px 28px",
                            fontWeight: 500,
                        }}
                        >
                        Submit
                        </Button>
                    )}
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default connect(null, { setLoading, setSnackInfo })(
    InitiationBomDataTable
);
